var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.75 16.65V15.15C12.75 14.3544 12.4339 13.5913 11.8713 13.0287C11.3087 12.4661 10.5456 12.15 9.75 12.15H3.75C2.95435 12.15 2.19129 12.4661 1.62868 13.0287C1.06607 13.5913 0.75 14.3544 0.75 15.15V16.65",
  stroke: "#DCDCDC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.75 9.15002C8.40685 9.15002 9.75 7.80688 9.75 6.15002C9.75 4.49317 8.40685 3.15002 6.75 3.15002C5.09315 3.15002 3.75 4.49317 3.75 6.15002C3.75 7.80688 5.09315 9.15002 6.75 9.15002Z",
  stroke: "#DCDCDC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 16.65V15.15C17.2495 14.4853 17.0283 13.8396 16.621 13.3142C16.2138 12.7889 15.6436 12.4137 15 12.2475",
  stroke: "#DCDCDC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3.2475C12.6453 3.41272 13.2173 3.78802 13.6257 4.31423C14.0342 4.84044 14.2559 5.48762 14.2559 6.15375C14.2559 6.81988 14.0342 7.46706 13.6257 7.99326C13.2173 8.51947 12.6453 8.89477 12 9.06",
  stroke: "#DCDCDC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0.900024H18V18.9H0V0.900024Z",
  fill: "white"
})));

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.66e981e6.svg";
export { ForwardRef as ReactComponent };